import { CompanyStatement } from "./components/CompanyStatement";
import { Footer } from "./components/Footer";
import { Founders } from "./components/Founders";
import { Hero } from "./components/Hero";
import { Navbar } from "./components/Navbar";

export function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CompanyStatement />
        <Founders />
      </main>
      <Footer />
    </>
  );
}
